import React, { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { faGithub, faLinkedin, faStackOverflow } from "@fortawesome/free-brands-svg-icons";
import { FaBars, FaTimes } from "react-icons/fa"; // Hamburger & close icons

const socials = [
  { icon: faEnvelope, url: "https://mail.google.com/mail/u/0/?tab=rm&ogbl#inbox?compose=CllgCJfpJsvtXfZjMqChgPhdpnWrJdhSTXGMvPmDjJvwCPtkLBXTDrKvjTQTLRZWTrfLlXsJCGq" },
  { icon: faGithub, url: "https://github.com/ahBC-dev" },
  { icon: faLinkedin, url: "https://www.linkedin.com/in/ahmad-hosseini-83a6a8237/" },
  { icon: faStackOverflow, url: "https://stackoverflow.com" },
];

const Header = () => {
  const headerRef = useRef(null);
  const lastScrollY = useRef(0);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleClick = (anchor) => (e) => {
    e.preventDefault();
    const element = document.getElementById(`${anchor}-section`);
    if (element) element.scrollIntoView({ behavior: "smooth", block: "start" });
    setMobileMenuOpen(false); // Close mobile menu on click
  };

  // Hide/show header on scroll
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (Math.abs(currentScrollY - lastScrollY.current) < 10) return;
      if (headerRef.current) {
        headerRef.current.style.transform =
          currentScrollY > lastScrollY.current ? "translateY(-200px)" : "translateY(0)";
      }
      lastScrollY.current = currentScrollY;
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      ref={headerRef}
      className="fixed top-0 left-0 right-0 z-50 bg-gray-900 shadow-lg transform transition-transform duration-300 ease-in-out"
    >
      <div className="max-w-[1280px] mx-auto flex justify-between items-center px-4 sm:px-8 md:px-16 py-4">
        {/* Social icons */}
        <div className="flex space-x-4">
          {socials.map((social, idx) => (
            <a key={idx} href={social.url} target="_blank" rel="noreferrer">
              <FontAwesomeIcon icon={social.icon} size="2x" className="text-white hover:text-blue-500 transition-colors" />
            </a>
          ))}
        </div>

        {/* Desktop nav */}
        <nav className="hidden md:flex space-x-8 text-white">
          <a href="/#projects-section" onClick={handleClick("projects")} className="hover:text-blue-500 transition-colors">Projects</a>
          <a href="/#contact-me-section" onClick={handleClick("contactme")} className="hover:text-blue-500 transition-colors">Contact Me</a>
        </nav>

        {/* Mobile menu button */}
        <button
          className="md:hidden text-white text-2xl focus:outline-none"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          {mobileMenuOpen ? <FaTimes /> : <FaBars />}
        </button>
      </div>

      {/* Mobile menu */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-gray-800 text-white flex flex-col items-center space-y-4 py-4">
          <a href="/#projects-section" onClick={handleClick("projects")} className="hover:text-blue-500 transition-colors text-lg">Projects</a>
          <a href="/#contact-me-section" onClick={handleClick("contactme")} className="hover:text-blue-500 transition-colors text-lg">Contact Me</a>
        </div>
      )}
    </header>
  );
};

export default Header;
